import { DEFAULT_LOCATIONS, NORTHROPGRUMMAN, DROPDOWN } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 16d5da70c339acd488ade20940cf39c20cfa3d0b',
  staging: 'Token 053db8c18ba5c106605a637bfcfedfa52d7a13a2',
  prod: 'Token f1332772606cf9bbc5dedf57cb184f35f85b0a06',
};

const token = selectToken(apiTokens);

const northropGrummanConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'northropgrumman',

  API_TOKEN: token,
  EMBOLD_CLIENT: NORTHROPGRUMMAN,

  // login
  SHOW_REGION_SELECTOR: true,
  NETWORKS: {},

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.FallsChurch },
  LOGIN_NETWORK_NAME: 'northropGrummanUserId',

  // content
  DISPLAY_NAME: 'Northrop Grumman',
  FORM_VARIANT: DROPDOWN,
  NO_WELCOME_LINK: false,
};

export default northropGrummanConfig;
